import { apiClient } from ".";
import { useMutation } from "@tanstack/react-query";

export const startSignUp = async ({
  personalNumber,
  transactionId,
}: {
  personalNumber: string;
  transactionId: string;
}) => {
  const response = await apiClient({
    url: `/auth/sign-up`,
    method: "POST",
    data: {
      username: personalNumber,
      transactionId,
    },
  });
  return response.data;
};

export const useStartSignUp = () =>
  useMutation({
    mutationFn: ({
      personalNumber,
      transactionId,
    }: {
      personalNumber: string;
      transactionId: string;
    }) => startSignUp({ personalNumber, transactionId }),
  });
